import { Route, Routes } from "react-router-dom";

const AssetInventoryRoute = (props:any) => {
  return (
      <Routes>
        {props?.AssetInventoryRouteOption.map((item:any,index:any) => (
          <Route key={index} path={item.path} element={<item.component />} />
        ))}
      </Routes>
  );
};

export default AssetInventoryRoute;
